import { render, staticRenderFns } from "./Parameter.vue?vue&type=template&id=2887e7f2&"
import script from "./Parameter.vue?vue&type=script&lang=js&"
export * from "./Parameter.vue?vue&type=script&lang=js&"
import style0 from "./Parameter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports